/*
 * サブシステム名：マスタ管理
 * 機能名：区分マスタ一覧
 */
import DdCustomButton from '@/components/DdCustomButton'

import date from '@/ddv2.library/date'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import { mapGetters } from 'vuex'

import header from '@/ddv2.library/header'

const DdDefaultButton = () => import('@/components/DdDefaultButton')
const DdFooterButton = () => import('@/components/DdFooterButton')

const DdCodeTextBox = () => import('@/components/DdCodeTextBox')
const DdDataTable = () => import('@/components/DdDataTable')
const DdDropDown = () => import('@/components/DdDropDown')
const DdIconButtonWithTooltip = () => import('@/components/DdIconButtonWithTooltip')
const DdNarrowDownTextBox = () => import('@/components/DdNarrowDownTextBox')
const DdRowCountBox = () => import('@/components/DdRowCountBox')
const DdSubHeader = () => import('@/components/DdSubHeader')

export default {
  name: 'MstKubunList',
  mixins: [flowMixin],
  data: () => ({
    expansionPanel: [0, 1],
    selected: [],
    conditions: {
      KbnShuruiCd: ''
    },
    modeKengen: 0,
    headersKbnSbtShuruiList: header.msysKubunShubetsuShurui,
    page: 1
  }),
  components: {
    DdCustomButton,
    DdDefaultButton,
    DdFooterButton,
    DdCodeTextBox,
    DdDataTable,
    DdDropDown,
    DdIconButtonWithTooltip,
    DdNarrowDownTextBox,
    DdRowCountBox,
    DdSubHeader
  },
  computed: {
    ...mapGetters({
      kubunList: 'DDMasters/msysKubun',
      kubunshubetsushuruiList: 'DDMasters/msysKubunShubetsuShurui',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      return this.rows.map((elem) => {
        elem.hyojiOrderDisp = elem.hyojiOrder ? filter.numericFormatter(elem.hyojiOrder) : ''
        return elem
      })
    },
    filteredKubunShubetsuShurui () {
      return this.kubunshubetsushuruiList.filter(function (elem) {
        return elem.kbnSbtKbn === 'K'
      }).map(function (elem) {
        elem.value = elem.kbnSbtShuruiCd
        elem.text = elem.kbnSbtShuruiNm
        return elem
      }).sort((elem1, elem2) => {
        if (elem1.hyojiOrder - elem2.hyojiOrder !== 0) { return elem1.hyojiOrder - elem2.hyojiOrder }
        if (elem1.kbnSbtShuruiCd > elem2.kbnSbtShuruiCd) { return 1 }
        if (elem1.kbnSbtShuruiCd === elem2.kbnSbtShuruiCd) { return 0 }
        return -1
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isEditButtonDisabled () {
      if (this.modeKengen === 0) {
        return true
      }
      if (this.selected.length === 1) {
        return false
      }
      return true
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        loadMasters: ['msyskubun', 'msyskubunshubetsushurui'],
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('MstKubunList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: 'コード', value: 'code' },
              { text: 'コード名称', value: 'codeNm' },
              { text: 'コード正式名称', value: 'codeSeishikiNm' },
              { text: '表示順', value: 'hyojiOrderDisp', align: 'end' },
              { text: '表示フラグ', value: 'hyojiFlgNm' },
              { text: '項目１', value: 'komoku1' },
              { text: '項目２', value: 'komoku2' },
              { text: '項目３', value: 'komoku3' },
              { text: '項目４', value: 'komoku4' },
              { text: '項目５', value: 'komoku5' }]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise(resolve => {
            self.conditions = {}
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('MstKubunList.savedInputRestorePromise', c)
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('MstKubunList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('MstKubunList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            this.$nextTick(function () {
              this.onSearchButtonClick()
              document.getElementById('heavy-element').style.display = ''
            })
          })
        },
        restoreViewPromise: (c) => {
          console.log('MstKubunList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('MstKubunList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      self.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      this.selected = []

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/vwCMsysKubun/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload

          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
            .then(() => {
            })
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },
    clear: function () {
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            console.log('MstKubunList.clearInputsPromise')

            this.conditions = {
              KbnShuruiCd: ''
            }
            this.searchText = ''
            this.rows = []
            this.selected = []
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      console.log('onRowEditButtonClick', item)
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCsvButtonClick: function (e) {
      this.HttpClient
        .post('/api/v1/vwCMsysKubun/download', this.conditions)
        .then((data) => {
          const ts = date.getCurrentDate().replaceAll('/', '') + '_' + date.getCurrentTime().replaceAll(':', '')
          const bom = new Uint8Array([0xEF, 0xBB, 0xBF])
          const blob = new Blob([bom, data], { type: 'text/csv' })
          const elem = document.getElementById('download')
          elem.href = window.URL.createObjectURL(blob)
          elem.download = '区分マスタ一覧_' + ts + '.csv'
          elem.click()
        })
    },
    searchValidate: function () {
      return true
    },
    usableDblClick (item) {
      return 'usable-dblclick'
    }
  }
}
